<template>
  <div class="container">
    <div class="heum-branch-hero">
      <div class="heum-branch-hero__container">
        <div class="heum-branch-hero__contents">
          <div class="heum-branch-hero__title">
            혜움 지점 안내
          </div>
          <div class="heum-branch-hero__subtitle">
            혜움을 함께 만들어가는<br />
            파트너 지점을 소개합니다.
          </div>
        </div>
      </div>
    </div>
    <content-section>
      <branch-item
        v-for="(branch, index) in branch"
        :key="index"
        :file="branch"
        :branch-name="branch.fields.branchName"
        :accountant-name="branch.fields.accountantName"
        :address="branch.fields.address"
        :map-url="branch.fields.mapUrl"
        :phone-number="branch.fields.phoneNumber"
        :homepage="branch.fields.homepage"
      />
    </content-section>
    <heum-join
      title="내 일처럼 고민하고 상담합니다. 혜움의 전문가를 만나보세요."
    />
  </div>
</template>

<script>
import ContentSection from '~/components/common/content-section'
import HeumJoin from '~/components/heum-join'
import BranchItem from '~/components/branch/branch-item'

import { createClient } from '~/plugins/contentful'
const contentfulClient = createClient()

export default {
  layout: 'invert-font-header',
  head: {
    title: '혜움지점 - 세무법인혜움'
  },
  components: {
    BranchItem,
    ContentSection,
    HeumJoin
  },
  asyncData({ env }) {
    return Promise.all([
      contentfulClient.getEntries({
        content_type: 'heum-branch',
        order: 'fields.weight'
      })
    ]).then(([branch]) => {
      return {
        branch: branch.items
      }
    })
  }
}
</script>

<style lang="scss">
.heum-branch-hero {
  position: relative;
  height: 660px;
  margin: 0;
  background-color: #000;
  background-image: url('/images/heum-branch/bg-hero-heum-branch-v2-m.jpg');
  background-repeat: no-repeat;
  background-position: right center;
  background-size: cover;

  @include av-mq(lap-and-up) {
    height: 708px;
    margin: 0 0 60px 0;
    background-image: url('/images/heum-branch/bg-hero-heum-branch-v2.jpg');
    background-position: right center;
  }

  &__container {
    position: relative;
    max-width: 1024px;
    height: 100%;
    margin: 0 auto;
    padding: 0 1rem;
  }

  &__contents {
    position: absolute;
    top: 50%;
    left: 1rem;
    transform: translateY(-50%);
    z-index: 2;
    text-align: left;
  }

  &__branch-logo {
    position: absolute;
    bottom: 65px;
    right: 20px;
    z-index: 2;
    width: 102px;

    @include av-mq(lap-and-up) {
      width: inherit;
    }

    img {
      max-width: 100%;
    }
  }

  &__title {
    margin-bottom: 11px;
    font-size: 16px;
    color: #fff;
    color: #fff;

    @include av-mq(lap-and-up) {
      font-size: 24px;
      margin-bottom: 1rem;
    }
  }

  &__subtitle {
    font-size: 26px;
    line-height: 1.48;
    color: #fff;
    z-index: 2;

    @include av-mq(lap-and-up) {
      margin-bottom: 2rem;
      font-size: 48px;
    }
  }
}
</style>
